"use client";
import { QueryClientProvider as TanstackProvider } from "@tanstack/react-query";
import { type ReactNode, useState } from "react";
import { getQueryClient } from "@/lib/queryClient";

/**
 * No navegador, o cliente do app inteiro (o mesmo `queryClient` que mutações e
 * logout usam). No servidor, um por visita: o `useState` guarda o cliente
 * daquela renderização, e a próxima visita nasce com cache vazio
 * (CHAT002-4991, o HTML de uma conta saía com a Academy de outra).
 */
export function QueryClientProvider({ children }: { children: ReactNode }) {
	const [client] = useState(getQueryClient);
	return <TanstackProvider client={client}>{children}</TanstackProvider>;
}
